<!--
 * @Description:
 * @Author: mdb
 * @Date: 2022-08-01 14:44:46
 * @LastEditTime: 2023-05-22 14:11:11
 * @LastEditors: cxh
-->
<template>
  <a-form ref="formRef" :model="dataForm" :rules="formRules" autocomplete="off" scrollToFirstError>
    <dc-layout-card title="基础信息" :span="6">
      <dc-form-item name="customerName" label="客户名称">
        <CosInputTianyancha
          appId="cos_fbu"
          v-model:value="dataForm.customerName"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item name="customerName" label="线索ID" v-if="props.type === 'view'">
        <CosInput v-model:value="dataForm.clueId" :disabled="!props.isEdit" view />
      </dc-form-item>
      <dc-form-item name="channel" label="线索来源" class="form-item_compact">
        <a-input-group compact class="cos-view-input-group">
          <ParamCodeCascader
            v-model:value="dataForm.channel"
            :cosDes="dataForm.channelExplain"
            appId="cos_fbu"
            paramCode="fbu_source_channel"
            :status="props.type === 'view' ? undefined : 0"
            :disabled="!props.isEdit"
            :view="props.type === 'view'"
            style="width: 33%"
          />
          <dc-form-item name="channelExplain" :span="24" style="width: 67%" class="last-compact">
            <CosInput
              v-model:value="dataForm.channelExplain"
              :maxlength="100"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
            />
          </dc-form-item>
        </a-input-group>
      </dc-form-item>
      <dc-form-item name="clueType" label="线索类型">
        <CosSelect
          v-model:value="dataForm.clueType"
          :options="clueTypeEnumComputed"
          :disabled="!props.isEdit || props.clueTypeDisabled"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item name="customerOffice" label="客户办公地" :rules="isPerfect ? formRules.customerOffice : []">
        <CustomerArea
          v-model:value="dataForm.customerOffice"
          change-on-select
          showSearch
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item name="customerAddress" label="客户详细地址">
        <!-- <MapModal
          v-model:address="dataForm.customerAddress"
          v-model:geoPoint="dataForm.geoPoint"
          :view="props.type === 'view'"
        /> -->
        <CosInput
          v-model:value.trim="dataForm.customerAddress"
          :maxlength="200"
          :disabled="!props.isEdit"
          placeholder="请输入"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item name="marketActivity" label="关联市场活动">
        <ParamCodesSelect
          v-model:value="dataForm.marketActivity"
          :options="paramCodeData.fbu_marketing_activity"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item name="customerRegion" label="客户区域">
        <CustomerAreaCascader
          appId="cos_fbu"
          v-model:value="dataForm.customerRegion"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        name="futureContactTime"
        label="未来联系时间"
        :rules="clueType ? formRules.futureContactTime : []"
        v-if="clueType"
      >
        <CosSingleDateTimePicker
          v-model:startTime="dataForm.futureContactTime"
          :isRange="false"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item name="follower" label="客户负责人">
        <UserSelect
          v-model:value="dataForm.follower"
          defaultValue="me"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          @change="handleFollowerChange"
        />
      </dc-form-item>
      <dc-form-item
        name="invalidId"
        label="无效原因"
        :rules="invalidClue ? formRules.invalidId : []"
        v-if="dataForm.clueType === 3"
      >
        <ParamCodesSelect
          v-model:value="dataForm.invalidId"
          :options="paramCodeData.fbu_invalid_reason"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <template v-if="!props.isEdit">
        <dc-form-item name="createByName" label="创建人">
          <CosInput v-model:value="dataForm.createByName" view />
        </dc-form-item>
      </template>
      <template v-if="!props.isEdit">
        <dc-form-item name="createTime" label="创建时间">
          <CosInput v-model:value="dataForm.createTime" view />
        </dc-form-item>
      </template>
      <dc-form-item name="contactStartTime" label="联系时间">
        <CosSingleDateTimePicker
          v-model:startTime="dataForm.contactStartTime"
          v-model:endTime="dataForm.contactEndTime"
          :isRange="true"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item name="remindFlag" label="提醒他处理线索">
        <CosRadioGroup v-model:value="dataForm.remindFlag" :view="props.type === 'view'" :options="flagEnum" />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item name="remark" label="备注" :span="12">
        <CosTextarea
          v-model:value="dataForm.remark"
          :maxlength="2000"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
    </dc-layout-card>

    <dc-layout-card title="联系人信息" :span="6">
      <dc-form-item label="联系人类型" :name="['contact', 'contactType']" :rules="formRules.contactType">
        <CosSelect
          v-model:value="dataForm.contact.contactType"
          :options="contactTypeEnum"
          :disabled="!props.isEdit"
          allowClear
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="联系人姓名" :name="['contact', 'name']" :rules="formRules.name">
        <CosInput
          v-model:value="dataForm.contact.name"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="手机号" :name="['contact', 'mobileRegion']" class="form-item_compact">
        <a-input-group compact class="cos-view-input-group">
          <ParamCodesSelect
            v-model:value="dataForm.contact.mobileRegion"
            :options="paramCodeData.fbu_area_code"
            :disabled="!props.isEdit"
            :view="props.type === 'view'"
            :cosDes="dataForm.contact.mobile"
            allowClear
            style="width: 33%"
          />
          <dc-form-item
            :span="24"
            style="width: 67%"
            :name="['contact', 'mobile']"
            :rules="{
              validator: (rule:any, value:any) => contactValidate(rule, value, dataForm.contact, formRef)
            }"
            class="last-compact"
          >
            <CosInput v-model:value="dataForm.contact.mobile" :disabled="!props.isEdit" :view="props.type === 'view'" />
          </dc-form-item>
        </a-input-group>
      </dc-form-item>
      <dc-form-item
        label="微信号"
        :name="['contact', 'wechat']"
        :rules="{
              validator: (rule:any, value:any) => contactValidate(rule, value, dataForm.contact, formRef)
            }"
      >
        <CosInput
          v-model:value="dataForm.contact.wechat"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        label="QQ号"
        :name="['contact', 'qq']"
        :rules="{
              validator: (rule:any, value:any) => contactValidate(rule, value, dataForm.contact, formRef)
            }"
      >
        <CosInput
          v-model:value="dataForm.contact.qq"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        label="邮箱"
        :name="['contact', 'email']"
        :rules="{
              validator: (rule:any, value:any) => contactValidate(rule, value, dataForm.contact, formRef)
            }"
      >
        <CosInput
          v-model:value="dataForm.contact.email"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="固定电话" :name="['contact', 'telRegion']" class="form-item_compact">
        <a-input-group compact class="cos-view-input-group">
          <ParamCodesSelect
            v-model:value="dataForm.contact.telRegion"
            :options="paramCodeData.fbu_area_code"
            :disabled="!props.isEdit"
            :view="props.type === 'view'"
            :cosDes="dataForm.contact.tel"
            allowClear
            style="width: 33%"
          />
          <dc-form-item
            :span="24"
            style="width: 67%"
            :name="['contact', 'tel']"
            :rules="{
              validator: (rule:any, value:any) => contactValidate(rule, value, dataForm.contact, formRef)
            }"
            class="last-compact"
          >
            <CosInput
              v-model:value="dataForm.contact.tel"
              :maxlength="100"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
            />
          </dc-form-item>
        </a-input-group>
      </dc-form-item>
      <dc-form-item label="角色" :name="['contact', 'tel']">
        <CosSelect
          v-model:value="dataForm.contact.jobRole"
          :options="linkRoleTypeEnum"
          :disabled="!props.isEdit"
          allowClear
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="部门职务" :name="['contact', 'jobDuty']">
        <CosInput
          v-model:value="dataForm.contact.jobDuty"
          :maxlength="100"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item label="性别" :name="['contact', 'sex']" :span="18">
        <CosRadioGroup v-model:value="dataForm.contact.sex" :options="genderEnum" :view="props.type === 'view'" />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item label="备注" :name="['contact', 'remark']" :span="12">
        <CosTextarea
          v-model:value="dataForm.contact.remark"
          :maxlength="2000"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
    </dc-layout-card>

    <dc-layout-card title="签到地址（添加后才能签到打卡）" :span="6">
      <template #title>
        <div style="display: flex; align-items: center; height: 24px; margin-bottom: 13px">
          <div class="dc-card-header-defaut-line"></div>
          <p style="font-size: 16px; font-weight: 500">签到地址</p>
          <span style="color: #999; font-size: 12px">（添加后才能签到打卡）</span>
          <div style="flex: 1 1 0%; text-align: right">
            <a-button type="primary" ghost @click="handleAddressAdd(dataForm.visitAddress)" v-if="props.isEdit"
              >新增</a-button
            >
          </div>
        </div>
      </template>
      <MultipleItem :view="props.type === 'view'" :line="false">
        <template v-for="(item, index) in dataForm.visitAddress" :key="index">
          <dc-form-item
            :label="index ? '' : '签到地址'"
            :class="index ? 'no-form-label' : ''"
            :name="['visitAddress', index, 'addressName']"
            :rules="[
            { validator: (rule:any, value:number) => checkAddressValidate(rule, value, dataForm.visitAddress, 'addressTag', '请选择') }
          ]"
          >
            <MapModal
              v-model:address="item.addressName"
              v-model:geoPoint="item.geoPoint"
              :view="props.type === 'view'"
            ></MapModal>
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '地址类型'"
            :class="index ? 'no-form-label' : ''"
            :name="['visitAddress', index, 'addressTag']"
            :rules="[
            { validator: (rule:any, value:number) => checkAddressValidate(rule, value, dataForm.visitAddress, 'addressName', '请输入') }
          ]"
          >
            <div class="flex">
              <ParamCodesSelect
                :options="paramCodeData.fbu_sign_in_address_label"
                v-model:value="item.addressTag"
                :disabled="!props.isEdit"
                :view="props.type === 'view'"
                allowClear
                style="width: 100%"
              />
              <a-button
                type="text"
                danger
                style="padding: 0 0 0 12px"
                v-if="props.isEdit && dataForm.visitAddress && dataForm.visitAddress.length > 1"
                @click="handleAddressAddDel(index, dataForm.visitAddress)"
                >删除</a-button
              >
              <a-checkbox style="padding: 3px 0 0 12px; width: 150px;" :disabled="props.type === 'view'" :checked="item.mainAddressFlag === 1" @change="clearMainAddressFlag(index)">主要</a-checkbox>
            </div>
          </dc-form-item>
          <a-col :span="12" />
        </template>
      </MultipleItem>
    </dc-layout-card>

    <dc-layout-card title="物流需求" :span="6">
      <template #subTitle v-if="props.isEdit">
        <a-button type="primary" ghost @click="handleWarehouseAdd()">新增</a-button>
      </template>
      <dc-form-item
        label="服务需求"
        :name="['business', 'demandInfo', 'demandIds']"
        :rules="isPerfect ? formRules.select : []"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.demandInfo.demandIds"
          :options="paramCodeData.fbu_service_demand"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item label="海外仓月消费总额（销售预估/万元）">
        <CosInput v-model:value.trim="amount" disabled :view="props.type === 'view'" placeholder="自动计算" />
      </dc-form-item>
      <dc-form-item
        label="海外仓月消费总额（市场预估）"
        :name="['business', 'demandInfo', 'totalAmount']"
        :rules="isPerfect ? [{ required: true, validator: selectForNumberValidate }] : []"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.demandInfo.totalAmount"
          :options="paramCodeData.fbu_important"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <MultipleItem :view="props.type === 'view'">
        <template v-for="(item, index) in dataForm.business.demandInfo.warehouses" :key="index">
          <dc-form-item
            :label="index ? '' : '需求海外仓'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'demandInfo', 'warehouses', index, 'warehouseId']"
            :rules="[{ required: isPerfect, validator: (rule:any, value:number) => checkValidate(rule, value, dataForm.business.demandInfo.warehouses, 'amount', '请选择') }]"
          >
            <ParamCodesSelect
              v-model:value="item.warehouseId"
              :options="paramCodeData.fbu_demand_info"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
              allowClear
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '月消费额(万)'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'demandInfo', 'warehouses', index, 'amount']"
            :rules="[{ required: isPerfect, validator: (rule:any, value:number) => checkValidate(rule, value, dataForm.business.demandInfo.warehouses, 'warehouseId', '请输入') }]"
          >
            <div class="flex">
              <CosInputNumber
                v-model:value="item.amount"
                :min="0"
                :maxlength="15"
                :disabled="!props.isEdit"
                :view="props.type === 'view'"
                style="width: 100%"
              />
              <a-button
                type="text"
                danger
                style="padding: 0 0 0 12px"
                v-if="
                  props.isEdit &&
                  dataForm.business.demandInfo.warehouses &&
                  dataForm.business.demandInfo.warehouses.length > 1
                "
                @click="handleWarehouseDel(index)"
                >删除</a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="12" />
        </template>
      </MultipleItem>
    </dc-layout-card>

    <dc-layout-card title="客户业务" :span="6">
      <template #subTitle v-if="props.isEdit">
        <a-button type="primary" ghost @click="handleSalePlatformAdd()">新增</a-button>
      </template>
      <dc-form-item
        label="销售平台(市场)"
        :name="['business', 'salePlatform']"
        :rules="isPerfect ? formRules.select : []"
      >
        <ParamCodesSelect
          v-model:value="dataForm.business.salePlatform"
          :options="paramCodeData.fbu_sale_platform"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item label="销售品类" :name="['business', 'salesCategory']" :rules="isPerfect ? formRules.select : []">
        <ParamCodesSelect
          v-model:value="dataForm.business.salesCategory"
          :options="paramCodeData.fbu_sales_category"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item label="产品货型" :name="['business', 'cargoType']" :rules="isPerfect ? formRules.select : []">
        <ParamCodesSelect
          v-model:value="dataForm.business.cargoType"
          :options="paramCodeData.fbu_product_type"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item label="客户类别" :name="['business', 'customerCategory']" :rules="formRules.select">
        <ParamCodesSelect
          v-model:value="dataForm.business.customerCategory"
          :options="paramCodeData.fbu_customer_category"
          :disabled="!props.isEdit"
          :view="props.type === 'view'"
          allowClear
          mode="multiple"
          :max-tag-count="!props.isEdit ? 100 : 'responsive'"
        />
      </dc-form-item>
      <dc-form-item label="是否产业带" :name="['business', 'industrialBeltFlag']" :rules="formRules.select">
        <CosRadioGroup
          v-model:value="dataForm.business.industrialBeltFlag"
          :options="flagEnum"
          @change="changeIndustrialBeltFlag"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        label="产业带"
        :name="['business', 'industrialBelt']"
        :rules="formRules.selectForNumber"
        v-if="dataForm.business.industrialBeltFlag === 1"
      >
        <ParamCodesSelect
          :options="paramCodeData.fbu_industrial_belt"
          v-model:value="dataForm.business.industrialBelt"
          v-model:label="dataForm.business.industrialBeltLabel"
          :view="props.type === 'view'"
          @change="changeIndustrialBeltLabel"
        />
      </dc-form-item>
      <dc-form-item
        label="产业带名称"
        :name="['business', 'industrialBeltName']"
        v-if="dataForm.business.industrialBelt && dataForm.business.industrialBeltLabel === '其他'"
        :rules="{
          message: '请输入',
          required: true
        }"
      >
        <CosInput
          v-model:value="dataForm.business.industrialBeltName"
          :maxlength="100"
          placeholder="请输入"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <MultipleItem :view="props.type === 'view'">
        <template v-for="(item, index) in dataForm.business.saleInfo" :key="index">
          <dc-form-item
            :label="index ? '' : '在售电商平台'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'saleInfo', index, 'salePlatformId']"
            :rules="[{ required: isPerfect, validator: (rule:any, value:number) => checkValidate(rule, value, dataForm.business.saleInfo, 'percent', '请选择') }]"
          >
            <ParamCodesSelect
              v-model:value="item.salePlatformId"
              :options="paramCodeData.fbu_sale_platform"
              :disabled="!props.isEdit"
              :view="props.type === 'view'"
              allowClear
            />
          </dc-form-item>
          <dc-form-item
            :label="index ? '' : '平台销量占比(%)'"
            :class="index ? 'no-form-label' : ''"
            :name="['business', 'saleInfo', index, 'percent']"
            :rules="[{ required: isPerfect, validator: percentValidate }]"
          >
            <div class="flex">
              <CosInputNumber
                v-model:value="item.percent"
                :min="0"
                :disabled="!props.isEdit"
                :view="props.type === 'view'"
                style="width: 100%"
              />
              <a-button
                type="text"
                danger
                style="padding: 0 0 0 12px"
                v-if="props.isEdit && dataForm.business.saleInfo && dataForm.business.saleInfo.length > 1"
                @click="handleSalePlatformDel(index)"
                >删除</a-button
              >
            </div>
          </dc-form-item>
          <a-col :span="12" />
        </template>
      </MultipleItem>
    </dc-layout-card>
  </a-form>

  <cos-footer-button
    v-model:value="dataForm"
    :formRef="formRef"
    :resetValue="resetValue"
    :loading="loading"
    :disabled="!props.isEdit"
    :permissionPage="permissionPage"
    @submit="handleSubmit"
  />
</template>

<script setup lang="ts">
import { ref, reactive, nextTick, computed, onBeforeMount, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
import { DcConfirm, message } from '@dc-platform/dc-components'
import { cloneDeep } from 'lodash-es'
import { contactValidate, concatNameValidate, selectForNumberValidate } from '@/utils/validate'
import CustomerArea from '@/components/CustomerArea'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { clueTypeEnum } from '@/views/gucangSales/clueManage/dataConfig'
import { contactTypeEnum, linkRoleTypeEnum, genderEnum, flagEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { listByParamCodes, fetchUsersByWorkCode } from '@/api/common'
import { salesClueCreate, salesClueActivate, salesClueEdit } from '@/api/gucangSales/clueManage'
import calc from '@/utils/calc'
import { initObjectVal, clearInvalid, paramCodesDataFilter } from '@/utils/index'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import type { ParamCodeItem } from '@/typings/common'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import MapModal from '@/components/MapModal/index.vue'
import {
  checkAddressValidate,
  checkAddressData,
  handleAddressAdd,
  handleAddressAddDel,
  clear
} from '@/hooks/addressArrValidate'
import CosInputTianyancha from '@/components/Antd/CosInputTianyancha/index.vue'

const router = useRouter()
const route = useRoute()

const props = defineProps({
  value: Object,
  isEdit: {
    type: Boolean,
    required: true
  },
  type: {
    type: String,
    required: true,
    validator(value: string) {
      return ['add', 'edit', 'view'].includes(value)
    }
  },
  clueTypeDisabled: {
    type: Boolean,
    default: false
  },
  resetValue: {
    type: [Object, Array]
  }
})

const permissionPage = computed(() => {
  return props.type === 'add' ? { save: 'fbu_clue_add_btn' } : { edit: 'fbu_clue_edit_btn', save: 'fbu_clue_edit_btn' }
})
const initForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: { demandInfo: { warehouses: [{}] }, saleInfo: [{}] },
  visitAddress: [{}]
})

const queryClueId = computed(() => route.query.clueId as string)
// 线索类型枚举
const clueTypeEnumComputed = computed(() => {
  const addList = clueTypeEnum.filter((item) => item.value === 1 || item.value === 2)
  const otherList = clueTypeEnum.filter((item) => item.value)
  return props.type === 'add' ? addList : otherList
})
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  fbu_invalid_reason: [], // 无效原因
  fbu_marketing_activity: [], // 关联市场活动
  fbu_area_code: [], // 手机区号
  fbu_service_demand: [], // 服务需求
  fbu_important: [], // 潜在收入
  fbu_demand_info: [], // 需求海外仓
  fbu_sale_platform: [], // 在售电商平台
  fbu_sales_category: [], // 销售品类
  fbu_product_type: [], // 产品货型
  fbu_customer_category: [] // 客户类别
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: [
      'fbu_invalid_reason',
      'fbu_marketing_activity',
      'fbu_area_code',
      'fbu_service_demand',
      'fbu_important',
      'fbu_demand_info',
      'fbu_sale_platform',
      'fbu_sales_category',
      'fbu_product_type',
      'fbu_sign_in_address_label',
      'fbu_industrial_belt',
      'fbu_customer_category'
    ]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    Object.assign(paramCodeData, res.data)
  })
}
onBeforeMount(() => {
  getByParamCodes()
})
// 获取当前用户的信息
const getFollowerInfo = (workCode: string) => {
  const employeeList = [workCode]
  fetchUsersByWorkCode({ employeeList }).then((res) => {
    const [followerInfo] = res.data
    if (followerInfo && followerInfo.fbuCustomerRegion != null) {
      dataForm.customerRegion = followerInfo.fbuCustomerRegion
    } else {
      dataForm.customerRegion = undefined
      setTimeout(() => formRef.value?.clearValidate('customerRegion'))
    }
  })
}
/// 文本识别
const clipParseInfo = (parseInfo: any) => {
  if (!parseInfo) {
    return
  }
  let allBlank = false
  if (!dataForm.contact.name && !dataForm.customerAddress && !dataForm.contact.mobile && !dataForm.remark) {
    allBlank = true
  }
  if (allBlank) {
    dataForm.contact.name = parseInfo.contactName
    dataForm.customerAddress = parseInfo.address
    dataForm.contact.mobile = parseInfo.phoneNum
    dataForm.remark = parseInfo.detail
    return
  }
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否替换原内容',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      dataForm.contact.name = parseInfo.contactName
      dataForm.customerAddress = parseInfo.address
      dataForm.contact.mobile = parseInfo.phoneNum
      dataForm.remark = parseInfo.detail
    }
  })
}
const formRef = ref<FormInstance>()
const dataForm = reactive<FbuSalesClueEditParams.RootObject>(cloneDeep(initForm))
const clueType = ref(false)
const invalidClue = ref(false)
const isPerfect = ref(false)
const formRules: Record<string, Rule[]> = {
  select: [{ required: true, message: '请选择' }],
  selectForNumber: [{ required: true, validator: selectForNumberValidate, message: '请选择' }],
  input: [{ required: true, message: '请输入' }],
  channel: [{ required: true, message: '请选择线索来源' }],
  clueType: [{ required: true, validator: selectForNumberValidate, message: '请选择线索类型' }],
  customerOffice: [{ required: true, message: '请选择客户办公地' }],
  futureContactTime: [{ required: true, message: '请选择未来联系时间' }],
  follower: [{ required: true, message: '请选择客户负责人' }],
  customerName: [{ required: true, message: '请输入客户名称' }],
  industrialBeltName: [{ required: true, message: '请输入产业带名称' }],
  invalidId: [{ required: true, validator: selectForNumberValidate, message: '请选择无效原因' }],
  contactType: [{ required: true, validator: selectForNumberValidate, message: '请选择联系人类型' }],
  name: [
    { required: true, message: '请输入联系人姓名' },
    {
      validator: concatNameValidate
    }
  ],
  contact: [{ validator: (rule: any, value: any) => contactValidate(rule, value, dataForm, formRef.value) }]
}
watch(
  () => route.query.isPerfect,
  (val) => {
    if (val === 'required') {
      isPerfect.value = true
    }
  },
  { immediate: true }
)
watch(
  () => dataForm.clueType,
  (val) => {
    // 控制未来线索必填校验
    if (val === 1) {
      clueType.value = true
    } else {
      clueType.value = false
      dataForm.futureContactTime = undefined
    }

    // 控制无效线索必填校验
    if (val === 3) {
      invalidClue.value = true
    } else {
      invalidClue.value = false
      dataForm.invalidId = undefined
    }
  },
  { immediate: true }
)
watch(
  () => props.value,
  (val) => {
    if (val) {
      // 处理后端返回 null、0、空数组的问题
      const formVal = {
        ...val
      }
      initObjectVal(formVal, initForm)
      // 处理需求海外仓和totalAmount 把0=》undefined
      if (!formVal.business.demandInfo.totalAmount) {
        formVal.business.demandInfo.totalAmount = undefined
      }
      if (formVal.business.demandInfo.warehouses.length) {
        formVal.business.demandInfo.warehouses.forEach((item: any) => {
          if (!item) return
          if (item.warehouseId != null) {
            item.warehouseId = item.warehouseId || undefined
          }
          if (item.amount === null) item.amount = undefined
        })
      }
      if (formVal.business.saleInfo.length) {
        formVal.business.saleInfo.forEach((item: any) => {
          if (!item) return
          if (item.salePlatformId != null) {
            item.salePlatformId = item.salePlatformId || undefined
          }
          if (item.percent === null) item.percent = undefined
        })
      }
      Object.assign(dataForm, clearInvalid(formVal))
    }
  },
  { immediate: true, deep: true }
)

const clearMainAddressFlag = (index: number) => {
  if (dataForm.visitAddress) {
    for (const [i, item] of dataForm.visitAddress.entries()) {
      if (index === i) {
        item.mainAddressFlag = item.mainAddressFlag === 1 ? 0 : 1
      } else {
        item.mainAddressFlag = 0
      }
    }
  }
}

const handleFollowerChange = (val: any) => {
  if (val && props.type === 'add') getFollowerInfo(val)
}

const goBack = () => {
  if (location.hostname === 'localhost') {
    router.back()
  } else {
    layoutTags.close()
  }
}
const changeIndustrialBeltFlag = () => {
  const { industrialBeltFlag } = dataForm.business
  if (industrialBeltFlag === 0) {
    dataForm.business.industrialBelt = -9
    dataForm.business.industrialBeltLabel = ''
    dataForm.business.industrialBeltName = ''
  }
}
const changeIndustrialBeltLabel = () => {
  nextTick(() => {
    const { industrialBeltLabel } = dataForm.business
    if (industrialBeltLabel && industrialBeltLabel !== '其他') {
      dataForm.business.industrialBeltName = ''
    }
  })
}
const checkValidate = (rule: any, value: number | string, arr: any, name: string, message: string) => {
  if (isPerfect.value && value == null) return Promise.reject(new Error(message))
  const index = rule.field.split('.').slice(-2)[0] * 1
  const list = arr || []
  let key = list[index][name]
  if (name === 'warehouseId' && key === -9) key = undefined
  if (key != null && key !== '' && (!value || value === -9)) {
    return Promise.reject(new Error(message))
  } else {
    return Promise.resolve()
  }
}
const percentValidate = async (rule: any, value: number) => {
  if (isPerfect.value && value == null) return Promise.reject(new Error('请输入平台销量占比'))
  const index = rule.field.split('.').slice(-2)[0] * 1
  const key = dataForm.business.saleInfo?.[index].salePlatformId
  if (key && key !== -9 && value == null) {
    return Promise.reject(new Error('请输入平台销量占比'))
  }
  const result = dataForm.business.saleInfo?.reduce((prev: number, curr: any) => calc.Add(prev, curr.percent || 0), 0)
  if (value && result !== 100) {
    return Promise.reject(new Error('在售平台占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}

const amount = computed(() => {
  const result = dataForm.business.demandInfo.warehouses?.reduce((sum, item) => {
    return calc.Add(sum, item.amount || 0)
  }, 0)
  return result || ''
})
const handleWarehouseAdd = () => {
  dataForm.business.demandInfo.warehouses?.push({ warehouseId: undefined, amount: undefined })
}
const handleWarehouseDel = (index: number) => {
  dataForm.business.demandInfo.warehouses?.splice(index, 1)
}
const handleSalePlatformAdd = () => {
  dataForm.business.saleInfo?.push({ salePlatformId: undefined, percent: undefined })
}
const handleSalePlatformDel = (index: number) => {
  dataForm.business.saleInfo?.splice(index, 1)
}

const loading = ref(false)
const handleSubmit = async () => {
  try {
    loading.value = true
    const params = cloneDeep(dataForm)
    // 地址为空清除、判断地址是否重复
    if (checkAddressData(dataForm.visitAddress)) {
      message.error('签到地址不可重复！')
      loading.value = false
      return false
    }
    const { visitAddress } = params
    params.visitAddress = clear(visitAddress, ['addressName', 'geoPoint'])
    // 新增、编辑的格式和详情不同、多传attrList
    if (JSON.stringify(params.visitAddress) === '[{}]') {
      params.visitAddress = { attrList: [] }
    } else {
      params.visitAddress = { attrList: params.visitAddress }
    }
    // 联系方式为空的字段需要删除，否则接口会报错
    // for (const key in params.contact) {
    //   if (params.contact[key] === '' || params.contact[key] == null) delete params.contact[key]
    // }
    params.business.demandInfo.warehouses = params.business.demandInfo.warehouses?.filter((item: any) => {
      return item.warehouseId != null && item.amount != null
    })
    params.business.saleInfo = params.business.saleInfo?.filter((item: any) => {
      return item.salePlatformId != null && item.percent != null
    })
    // 清空产业带名称
    if (params.business.industrialBeltFlag !== 1) {
      params.business.industrialBeltName = ''
    }
    if (queryClueId.value) {
      params.id = queryClueId.value
      if (params.customerRegion === undefined) {
        params.customerRegion = ''
      }
      await salesClueEdit(params)
      message.success('修改线索成功')
      goBack()
    } else {
      const data = await salesClueCreate(params, { custom: { errorMsg: false } })
      if (data.code === 200) {
        message.success('新增线索成功')
        goBack()
      } else if (data.code === 13000059) {
        DcConfirm.warning({
          title: '操作提示！',
          content: data.message,
          cancelText: '取消',
          okText: '继续',
          onOk() {
            salesClueActivate(params).then(() => {
              message.success('新增线索抢占成功')
              goBack()
            })
          }
        })
      } else {
        message.error(data.message)
      }
    }
  } catch (errorInfo: any) {
    loading.value = false
    formRef.value?.scrollToField(errorInfo.errorFields[0].name.toString())
  }
  loading.value = false
}
</script>
<script lang="ts">
export default { name: 'DetailForm' }
</script>

<style lang="scss" scoped>
:deep(.form-item_compact) {
  > .ant-form-item-control {
    .ant-form-item-explain {
      top: 100%;
    }
  }
}
:deep(.last-compact) {
  > .ant-form-item-control {
    .ant-form-item-explain {
      top: 100%;
    }
  }
}
</style>
